// Generated from src/img/svg/delete.svg

export const Delete = (props) => {
  return (
    <svg height="16" viewBox="0 0 12.444 16" width="12.444" {...props}>
      <path
        d="M8.389 18.722a1.783 1.783 0 0 0 1.778 1.778h7.111a1.783 1.783 0 0 0 1.778-1.778V8.056H8.389ZM19.944 5.389h-3.111l-.889-.889H11.5l-.889.889H7.5v1.778h12.444Z"
        style={{ fill: "#a2a2a2" }}
        transform="translate(-7.5 -4.5)"
      />
    </svg>
  );
};
